import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

function ProtectedRoute({ children }) {
    const { isAuthorized, isLoading } = useAuth();

    if (isLoading) {
        return <div>Loading...</div>; // Or any other loading indicator
    }

    return isAuthorized ? children : <Navigate to="/login" />;
}

export default ProtectedRoute;